import { Box, styled, makeStyles } from '@material-ui/core';
import { SButton, SText } from '@setvi/shared/components';

export const StepperContainer = styled(Box)(({ theme }) => ({
  width: '280px',
  borderRight: '1px solid #E5E5E5',
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
}));

export const ContentContainer = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'hidden'
}));

export const Content = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(3),
  overflow: 'auto'
}));

export const Footer = styled(Box)(({ theme }) => ({
  borderTop: '1px solid #E5E5E5',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: '24px',
  backgroundColor: '#FFFFFF'
}));

export const StepItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '12px',
  gap: '8px',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  backgroundColor: '#fff',

  '&:hover': {
    backgroundColor: '#EBF5FF'
  }
});

export const StepContent = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
});

export const StepLabel = styled(SText)({
  fontSize: '14px',
  color: '#5D7083'
});

export const WarningContainer = styled(Box)({
  position: 'absolute',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bottom: 10
});

export const DismissBtn = styled(SButton)({
  borderRadius: 120,
  color: '#5D7083'
});

export const useTooltipStyles = makeStyles({
  tooltip: {
    padding: 12,
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: 0,
    fontFamily: 'var(--Family-Main, Roboto)',
    backgroundColor: '#20262D',
    color: '#EEF0F2'
  },
  arrow: {
    color: '#20262D'
  }
});
